import { render, staticRenderFns } from "./addDrugCompanies.vue?vue&type=template&id=78566d60&scoped=true"
import script from "./addDrugCompanies.vue?vue&type=script&lang=js"
export * from "./addDrugCompanies.vue?vue&type=script&lang=js"
import style0 from "./addDrugCompanies.vue?vue&type=style&index=0&id=78566d60&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78566d60",
  null
  
)

export default component.exports